import { Component, input } from '@angular/core';

@Component({
  selector: 'app-feature',
  template: `
    <div class="relative px-6 pb-6 md:px-8">
      <div class="-mb-2 -translate-y-1/2 md:-mb-4">
        <img
          class="h-16 md:h-20"
          src="{{ img() }}"
          alt="{{ title() }}"
          title="{{ title() }}"
        />
      </div>
      <div>
        @if (new()) {
          <app-public-tag>nouveau</app-public-tag>
        }
        <div class="font-bold" [class.mt-2]="new()">{{ title() }}</div>
        <div>{{ description() }}</div>
        @if (logo()) {
          <div class="mt-2">
            <img ngSrc="{{ logo() }}" width="134" height="16" alt="Dormakaba" />
          </div>
        }
      </div>
    </div>
  `,
  standalone: false,
})
export class FeatureComponent {
  img = input.required<string>();
  title = input.required<string>();
  description = input.required<string>();
  new = input<boolean>();
  logo = input<string>();
}
